<template>
  <v-row  >
    <v-col cols="12">
      <v-card>
        <v-card-text v-for="(rule, index) in rules" :key="index">
          <vue-markdown v-if="rule.rulesMarkdown" :source="rule.rulesMarkdown"></vue-markdown>
          <v-textarea v-if="editMode" v-model="rule.rulesMarkdown"></v-textarea>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import VueMarkdown from "vue-markdown";
import { mapActions } from "vuex";
export default {
  name: "CommissionRule",
  props: {
    editMode: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  data() {
    return {
      rules: []
      // rule: {
      //   Id: 0,
      //   rulesMarkdown: "i am a ~~tast~~ **test**."
      // }
    };
  },
  components: {
    VueMarkdown
  },
  methods: {
    ...mapActions("commissions", ["CommissionsRequest"]),
    loadRules() {
      let query = {
        message: "Commissions Rules loaded",
        url: `Commissions/GetRules`,
        method: "get",
        body: {}
      };
      this.CommissionsRequest(query)
        .then(data => {
          this.rules = data;
          this.$emit("rulesLoaded", data);
        })
        .catch(() => {});
    },
    saveRules() {
      let query = {
        message: "Commissions Rules saved",
        url: `Commissions/EditRule`,
        method: "post",
        body: this.rules
      };
      this.CommissionsRequest(query)
        .then(data => {
          this.$emit("rulesSaved", data);
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
</style>